import { formatDate } from "Shared/util/formatters";
import isValid from "date-fns/isValid";

export const translateColumns = (columns, translations) =>
    columns.map((column) => {
        const columnTitle = translations[column.title];
        return {
            ...column,
            title: columnTitle || (column.title ? `[${column.title}]` : ""),
        };
    });

export const funcFilterStatusWithDate = (param, t, property) => {
    if (Array.isArray(param)) {
        return param.map((item) => {
            if (t[item[property]]) {
                item = { ...item, [property]: t[item[property]] };
            } else if (item[property] === "") {
                item = { ...item, [property]: "" };
            } else {
                item = { ...item, [property]: `[${item[property]}]` };
            }
            return item;
        });
    }
    return param;
};

// NOTE - Se till att denna funktion anropas bara en gång.
// Om samma objekt skickas till översättning mer än en gång, då försöker funktionen översätta en tag som redan är översatt till det valda språket.
export const funcFilterStatus = (param, t, property) => {
    if (Array.isArray(param)) {
        return param.map((item) => {
            if (t[item[property]]) {
                item = { ...item, [property]: t[item[property]] };
            } else if (item[property] === "") {
                item = { ...item, [property]: "" };
            } else {
                item = { ...item, [property]: `[${item[property]}]` };
            }
            return item;
        });
    }

    if (param[property] !== "") {
        if (t[param[property]]) {
            param = { ...param, [property]: t[param[property]] };
        } else {
            param = { ...param, [property]: `[${param[property]}]` };
        }
    }
    return param;
};

export const funcFilterProperties = (param, t, properties, propertyToDisplay) =>
    param.map((item) => {
        const text = properties.reduce((acc, propertyItem) => {
            if (t[item[propertyItem]]) {
                acc += t[item[propertyItem]];
            } else if (isValid(new Date(item[propertyItem]))) {
                acc += formatDate(item[propertyItem]);
            } else if (item[propertyItem] || item[propertyItem] === "") {
                acc += item[propertyItem];
            } else {
                acc += propertyItem;
            }
            return `${acc} `;
        }, "");

        if (text) {
            item = { ...item, [propertyToDisplay]: text.trimEnd() };
        }
        return item;
    });

export const getPieChartData = (pieChartStatusInfo, invoices, dbProp, t) => {
    const chartData = invoices.reduce((acc, obj) => {
        const existingObject = acc.find((o) => o.event === obj[dbProp]);
        if (!existingObject) {
            const { normalizedRemainingAmount } = obj;
            const pcsi = pieChartStatusInfo.find(
                (s) => s.status === obj[dbProp],
            );
            acc.push({
                event: obj[dbProp],
                eventTranslated: t[pcsi.status],
                count: 1,
                amount:
                    Math.sign(normalizedRemainingAmount) > 0
                        ? normalizedRemainingAmount
                        : 0,
                sortOrder: pcsi ? pcsi.sortOrder : 0,
                color: pcsi ? pcsi.color : "rgba(225,225,225,1)",
            });
            return acc;
        }

        existingObject.count += 1;
        existingObject.amount +=
            Math.sign(obj.normalizedRemainingAmount) > 0
                ? obj.normalizedRemainingAmount
                : 0;

        return acc;
    }, []);

    chartData.sort((a, b) => a.sortOrder - b.sortOrder);
    const chartColors = chartData.map((obj) => obj.color);

    return {
        chartData,
        chartColors,
    };
};
